import { TimeRanges, Override } from "@bryntum/schedulerpro";

Override.apply(class {
  static target = {
    class: TimeRanges,
    product: "schedulerpro"
  }

  get state() {
    // by default the this.showCurrentTimeLine doesn't update correctly when timeline is set to off from populateTimeAxisHeaderMenu
    return { showCurrentTimeLine : !!this.currentTimeLine };
  }
})
